<template>
  <div>
    
    <header class="header">
      <h1 class="title">{{$t('forgotPassword.header.title')}}</h1>
      <h2 class="subtitle">{{$t('global.orConjunction')}} <router-link :to="'/'">{{$t('global.login')}}</router-link></h2>
    </header>

    <div v-if="!emailSent && needConfirm">
      <fieldset class="form">
        <div v-html="needConfirm.body"></div>
      </fieldset>

      <div class="buttons">
        <button ref="buttonConfirm" class="button is-primary is-large" @click="confirm">{{$t('global.confirm')}}</button>
      </div>
    </div>

    <form @submit.prevent="resend" v-else-if="!emailSent" novalidate>
      <fieldset class="form">
        <zul-input type="text"  v-model="user.document" name="document" key="document-input" icon="document" v-validate="'required|document'" label="CPF / CNPJ" :mask="documentMask()"></zul-input>
        <zul-input type="email" v-model="user.email"    name="email"    key="email-input"    icon="email"    v-validate="'required|email'"    label="E-mail"></zul-input> 
      </fieldset>

      <div class="buttons">
        <button ref="button" class="button is-primary is-large">{{$t('global.send')}}</button>
      </div>
    </form>

    <div v-else>
      <div class="form" v-html="msg"></div>
      <div class="buttons">
        <router-link :to="'/'"><button class="button is-text is-large">{{$t('global.backLogin')}}</button></router-link>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      user: {},
      needConfirm: false,
      emailSent: false,
      msg: ''
    }
  },
  methods: {
    resend () {
      this.$validator.validateAll()
        .then(isValid => {
          if (isValid) {
            // disable button
            this.$refs.button.classList.add('is-loading')
      
            this.$http.get('auth/password/resend', { params: { document: this.user.document.replace(/[./-]/g, ''), email: this.user.email } })
              .then(res => {
                switch (res.status) {
                  case 202:
                    this.confirm()
                    break
                  case 204:
                    this.emailSent = true
                    this.msg = res.data.body && res.data.body.replace('#00A800', this.color)
                    break
                  case 206:
                  case 207:
                    this.needConfirm = {
                      title: res.data.title,
                      body: res.data.body && res.data.body.replace('#00A800', this.color)
                    }
                    break
                  default:
                    this.$refs.button.classList.remove('is-loading')
                    break
                }
              })
          }
        })
    },

    confirm () {
      const data = new FormData()
      data.append('document', this.user.document.replace(/[./-]/g, ''))
      data.append('email', this.user.email)

      if (this.needConfirm) {
        this.$refs.buttonConfirm.classList.add('is-loading')
      }

      this.$http.post('auth/password/resend', data)
        .then(res => {
          if (this.needConfirm) {
            this.$refs.buttonConfirm.classList.remove('is-loading')
          }

          if (res.status === 200) {
            this.emailSent = true
            this.msg = res.data && res.data.body.replace('#00A800', this.color)
          }
        })
    },

    documentMask () {
      return this.user.document && this.user.document.replace(/[./-]/g, '').length > 11 ? '##.###.###/####-##' : '###.###.###-##'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .form {
    color: white;
  }
</style>
